
import React from 'react';
import ProfileAvatarContainer from './ProfileAvatarContainer';
import { ProfileAvatarProps } from './types';

const ProfileAvatar: React.FC<ProfileAvatarProps> = (props) => {
  return <ProfileAvatarContainer {...props} />;
};

export default ProfileAvatar;
